import { render, staticRenderFns } from "./ReferenceField.vue?vue&type=template&id=649a9aa8&"
import script from "./ReferenceField.vue?vue&type=script&lang=js&"
export * from "./ReferenceField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports